import React from 'react'
import PropTypes from 'prop-types'
import { validDate } from '../../helpers/'

export default function InputDAte(props) {
  let label = props.label
  let name = props.name
  let value = props.value
  let inputClassArray = ['form-control', 'w-100', 'form-control-sm']

  let error = []

  if (props.error) {
    props.error.map(e => {
      return error.push(e)
    })
    inputClassArray.push('is-invalid')
  }

  if (props.value !== '' && !validDate(props.value)) {
    inputClassArray.push('is-invalid')
    error.push('DD-MM-YYYY')
  }

  let inputClass = inputClassArray.join(' ')

  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <input
        type="text"
        name={name}
        id={name}
        placeholder="DD-MM-YYYY"
        onChange={props.handler}
        value={value}
        className={inputClass}
      />
      <div className="invalid-feedback">
        {error.map((e, k) => {
          return <li key={k}>{e}</li>
        })}
      </div>
    </div>
  )
}

InputDAte.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handler: PropTypes.func.isRequired,
  error: PropTypes.array,
}
